import React from 'react'
import { CheckCircle } from 'lucide-react'

const ThankYouPage: React.FC = () => {
  return (
    <div style={{ backgroundColor: 'rgb(246, 246, 241)', minHeight: '100vh', padding: '2rem 0' }}>
      <div className="mx-auto max-w-2xl px-8 text-center">
        <CheckCircle className="w-20 h-20 mx-auto mb-6" style={{ color: '#145F6B' }} />

        <h1 className="text-4xl font-bold mb-4" style={{ color: '#145F6B' }}>
          Thank You! Your Home Refresh is Booked.
        </h1>

        <p className="text-lg mb-8" style={{ color: 'rgb(76,76,75)' }}>
          We've received your booking and payment. Welcome to the Hudson My Home experience!
        </p>

        <div className="bg-white p-6 rounded-xl text-left">
          <h2 className="text-2xl font-semibold mb-6" style={{ color: 'rgb(15,15,15)' }}>
            What to Expect Next
          </h2>

          <div className="space-y-4">
            <div>
              <h3 className="text-lg font-semibold mb-2" style={{ color: 'rgb(15,15,15)' }}>
                1. Confirmation Call
              </h3>
              <p className="text-base" style={{ color: 'rgb(76,76,75)' }}>
                Our scheduling team will call you at the number provided within one business day to
                confirm your appointment.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-2" style={{ color: 'rgb(15,15,15)' }}>
                2. Service Visit
              </h3>
              <p className="text-base" style={{ color: 'rgb(76,76,75)' }}>
                Your Hudson will arrive on the scheduled date to perform your Home
                Refresh service.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-2" style={{ color: 'rgb(15,15,15)' }}>
                3. Report & Gift Card
              </h3>
              <p className="text-base" style={{ color: 'rgb(76,76,75)' }}>
                After the visit, you will receive your detailed MyHome Snapshot™ report and your
                $100 gift card via email.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ThankYouPage

